import { createReducer, createActions } from 'reduxsauce'
import { normalize } from 'utils/normalizer'

// Initial State
export const initialState = {
    newGameTemplate: null,
    newGameConfiguration: null,
    game: null,
    players: {
        ids: [],
        byId: {}
    },
    timeline: [],
    gameList: [],
}

// Types and Action Creators
const { Types, Creators } = createActions(
    {
        clean: null,
        setNewGameTemplate: ['tmpl'],
        addToNewGameTemplate: ['data'],
        setNewGameConfiguration: ['data'],
        setNewGameCode: ['gameCode'],
        setGame: ['game'],
        setPlayers: ['players'],
        setTimeline: ['timeline'],
        addLogToTimeline: ['log'],
        setGameList: ['list'],

        // Async actions
        requestNewGameTemplate: null,
        handleNewGameTemplateData: ['response'],
        newGameSaveStep1: ['data'],
        newGameSaveStep2: ['data'],
        requestNewGame: ['data'],
        handleNewGameData: ['response'],
        requestBotsDefaultValues: ['gameCode'],
        handleBotsDefaultValues: ['response'],
        updateGameBots: ['data'],
        handleGameBotsUpdated: ['response'],
        requestGameData: ['data'],
        handleGameData: ['response'],
        handleGameLogData: ['response'],
        handleServerError: ['response'],
        requestGameList: null,
        handleGameList: ['response'],
        requestGameCSV: ['code'],
        handleGameCSV: ['response'],
    },
    {
        prefix: 'MC_'
    }
)

export const McTypes = Types

// Reducers and Handlers
export const handlers = {
    [Types.CLEAN]: () => ({ ...initialState }),
    [Types.SET_NEW_GAME_TEMPLATE]: (state = initialState, { tmpl }) => ({ ...state, newGameTemplate: tmpl }),
    [Types.ADD_TO_NEW_GAME_TEMPLATE]: (state = initialState, { data }) => ({ ...state, newGameTemplate: { ...state.newGameTemplate, ...data } }),
    [Types.SET_NEW_GAME_CONFIGURATION]: (state = initialState, { data }) => ({ ...state, newGameConfiguration: data }),
    [Types.SET_NEW_GAME_CODE]: (state = initialState, { gameCode }) => ({ ...state, newGameConfiguration: { ...state.newGameConfiguration, gameCode } }),
    [Types.SET_GAME]: (state = initialState, { game }) => ({
        ...state,
        game: {
            ...state.game,
            ...game,
            seasons: {
                ...(state.game || {}).seasons,
                [game.requestedSeason || game.currentSeason]: game.decisions
            }
        }
    }),
    [Types.SET_PLAYERS]: (state = initialState, { players }) => ({ ...state, players: normalize(players, 'id') }),
    [Types.SET_TIMELINE]: (state = initialState, { timeline }) => ({ ...state, timeline }),
    [Types.ADD_LOG_TO_TIMELINE]: (state = initialState, { log }) => ({ ...state, timeline: [log, ...state.timeline] }),
    [Types.SET_GAME_LIST]: (state = initialState, { list }) => ({ ...state, gameList: list || [] }),
}

export const reducer = createReducer(initialState, handlers)

export default Creators



// WEBPACK FOOTER //
// src/store/redux/mc.js